export default "__VITE_ASSET__BQicgyPI__"